import * as Services from './services';

export const providers = [Services.OrientationService];
